import { useEffect, useState } from 'react';
import ApiService from '../services/api';
import { getTenantSlug } from '../utils/appOrigin';

// Module-level cache: branding is static per subdomain, fetch it once per page load.
let cached; // undefined = not fetched yet, null = no branding, object = branding
let inflight = null;

/**
 * Tenant branding for the current subdomain (<slug>.testera.io).
 * Returns: undefined while loading, null when there is no branded portal for
 * this host (or on the main app host), or the branding object.
 */
export default function useTenantBranding() {
  const slug = getTenantSlug();
  const [brand, setBrand] = useState(cached);

  useEffect(() => {
    if (!slug || cached !== undefined) return;
    if (!inflight) {
      inflight = ApiService.getPublicBranding(slug)
        .then((b) => { cached = b?.name ? b : null; return cached; })
        .catch((e) => {
          // 404 => subdomain not enabled. Transient errors stay "loading" so
          // we never bounce a legit tenant off their portal due to a blip.
          if (e?.status === 404) { cached = null; return null; }
          inflight = null;
          return undefined;
        });
    }
    let active = true;
    inflight.then((b) => { if (active && b !== undefined) setBrand(b); });
    return () => { active = false; };
  }, [slug]);

  return slug ? brand : null;
}
